module.exports = __webpack_public_path__ + "static/media/6.89480e84.jpg";